import { Link } from "react-router-dom";
import { motion } from "framer-motion";


const RelatedProducts = ({
  products,
  currentProduct
}) => {


  const relatedProducts = products
  .filter(
    (product) =>
      product.category?._id === currentProduct.category?._id &&
      product._id !== currentProduct._id
  )
  .slice(0,4);



  if (relatedProducts.length === 0) {
    return null;
  }


  return (
    <section
      className="
        mt-10
        bg-white
        rounded-3xl
        border
        border-gray-200
        p-6
        lg:p-10
      "
    >

      <h2
        className="
          text-2xl
          font-bold
          text-gray-900
        "
      >
        Related Products
      </h2>



      <div
        className="
          mt-8
          grid
          grid-cols-1
          sm:grid-cols-2
          lg:grid-cols-4
          gap-6
        "
      >

        {
          relatedProducts.map((product, index) => (

            <motion.div

              key={product._id}

              initial={{
                opacity:0,
                y:30
              }}

              whileInView={{
                opacity:1,
                y:0
              }}

              transition={{
                duration:0.4,
                delay:index * 0.1
              }}

              viewport={{
                once:true
              }}

              className="
                border
                border-gray-200
                rounded-2xl
                overflow-hidden
                hover:shadow-lg
                transition
              "
            >


              {/* Image */}

              <div
                className="
                  h-48
                  bg-gray-100
                  flex
                  items-center
                  justify-center
                "
              >

                <img
                  src={product.image?.asset?.url}
                  alt={product.name}
                  className="
                    w-full
                    h-full
                    object-contain
                  "
                />

              </div>



              {/* Content */}

              <div className="p-5">


                <h3
                  className="
                    font-semibold
                    text-gray-900
                    line-clamp-2
                  "
                >
                  {product.name}
                </h3>



                <p
                  className="
                    mt-2
                    text-green-600
                    font-bold
                  "
                >
                  {`TZS ${Number(product.price).toLocaleString()}`}
                </p>



                <Link
                  to={`/product/${product._id}`}
                  className="
                    block
                    mt-4
                    text-center
                    border
                    border-green-600
                    text-green-600
                    py-2
                    rounded-xl
                    hover:bg-green-600
                    hover:text-white
                    transition
                  "
                >
                  View Product
                </Link>


              </div>


            </motion.div>

          ))
        }


      </div>


    </section>
  );
};


export default RelatedProducts;